import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload Release Dates.
 *
 * @param {number} SourceId Source Id
 * @param {number} SiteId Site Id
 * @param {file} File Either a csv or excel file
 * @param {removeReleaseDate} RemoveReleaseDate bool Either a csv or excel file
*/
export default function postReleaseDatesPluId({
  SourceId,
  SiteId,
  File,
  removeReleaseDate,
}) {
  const endpoint = `/oc-product-bulkapi/v1/bulk-process/release-dates/plu-id/${SourceId}`;

  const body = new FormData();
  body.append('SiteId', SiteId);
  body.append('File', File);
  body.append('RemoveReleaseDate', removeReleaseDate);

  return new Promise((resolve, reject) => {
    postRequest(
      endpoint,
      body,
      'Release Dates (PLU)',
      'STARTED: Started : Release Dates : PLU (Update)',
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
